import {sentConstants} from "../../constants";

const initialState = {
  SentList: {},
  SentOrgList: {},
  isLoading: false,
  isFailure: false,
  isDelete: false,
  isSubmit: false,
  isCollect: false,
  isSubDoc: false,
  receiverList: [],
}

export default function sent(state = initialState, action) {
  switch (action.type) {
      /***********
       송신함 검색조건 변경
       ************/
    case sentConstants.SELECT_SEARCH_REQUEST:
      return {
        ...state,
        selectInfo: action.payload
      }

    /*********
     송신함 목록 조회
     **********/
    case sentConstants.SENT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case sentConstants.SENT_SUCCESS:
      return {
        ...state,
        SentList: action.response.data?.payload,
        isDelete: false,
      }
    case sentConstants.SENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
     송신함 원본 목록 조회
     **********/
    case sentConstants.SENT_ORG_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case sentConstants.SENT_ORG_SUCCESS:
      return {
        ...state,
        SentOrgList: action.response.data?.payload,
        isDelete: false,
      }
    case sentConstants.SENT_ORG_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

      /*********
       송신함 증명서 상세 조회
       **********/
    case sentConstants.DETAIL_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case sentConstants.DETAIL_SUCCESS:
      return {
        ...state,
        sentInfo: action.response.data?.payload,
        isFailure: false
      }
    case sentConstants.DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /***********
     송신함 증명서 상세 선택
     ************/
    case sentConstants.SELECT_REQUEST:
      return {
        ...state,
        info: action.payload
      }

    /*********
     송신함 증명서 반려
     **********/
    case sentConstants.WITHDRAW_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
        isSubmit: false,
        isFailure: false,
        isCollect: false,
      }
    case sentConstants.WITHDRAW_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSubmit: true,
        isCollect: true,
      }
    case sentConstants.WITHDRAW_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
        isSubmit: false,
      }

      /***********
       증명서 송신함 히스토리 관리
       ************/
    case sentConstants.SENT_HISTORY:
      return {
        ...state,
        history: action.payload
      }

    /***********
     증명서 제출 첨부문서 row 최신화
     ************/
    case sentConstants.CHANGE_FILE_REQUEST:
      return {
        ...state,
        fileList: action.payload
      }

    /***********
     송신함 PDF 발급요청
    ************/
    case sentConstants.SUB_SENT_DOC_PDF_REQUEST:
      return {
        ...state,
      }
    case sentConstants.SUB_SENT_DOC_PDF_SUCCESS:
      return {
        ...state,
        isFailure: false,
        isSubDoc: true,
      }
    case sentConstants.SUB_SENT_DOC_PDF_FAILURE:
      return {
        ...state,
        isFailure: true,
      }

    default:
      return state
  }
}
